import axios from 'axios';

const BASE = '/api/services/reservare-be/admin';

export interface AdminUserDto {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isAdmin: boolean;
  status: string;
  emailVerified: boolean;
  salonId: string | null;
  salonName: string | null;
  createdAt: string;
}

export interface AdminSalonDto {
  id: string;
  name: string;
  slug: string | null;
  isActive: boolean;
  email: string | null;
  phone: string | null;
  createdAt: string;
}

export interface AdminBookingDto {
  id: string;
  code: string;
  state: string;
  start: string;
  end: string;
  customerName: string;
  customerEmail: string | null;
  workerName: string | null;
  salonName: string;
  totalAmount: number;
}

export interface TopSalonStat {
  salonId: string;
  salonName: string;
  bookingCount: number;
  totalRevenue: number;
}

export interface AdminStatisticsDto {
  totalUsers: number;
  totalSalons: number;
  totalBookings: number;
  totalRevenue: number;
  bookingsLast30Days: number;
  newUsersLast30Days: number;
  topSalons: TopSalonStat[];
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

const auth = { withCredentials: true, headers: { 'X-Auth': 'Auth0' } };

export const fetchAdminUsers = (page = 0, size = 20, query?: string) =>
  axios
    .get<PageResponse<AdminUserDto>>(`${BASE}/users`, { params: { page, size, query }, ...auth })
    .then(r => r.data);

export const fetchAdminSalons = (page = 0, size = 20, query?: string) =>
  axios
    .get<PageResponse<AdminSalonDto>>(`${BASE}/salons`, { params: { page, size, query }, ...auth })
    .then(r => r.data);

export const fetchAdminReservations = (page = 0, size = 20) =>
  axios
    .get<PageResponse<AdminBookingDto>>(`${BASE}/reservations`, { params: { page, size }, ...auth })
    .then(r => r.data);

export const fetchAdminStatistics = () =>
  axios.get<AdminStatisticsDto>(`${BASE}/statistics`, auth).then(r => r.data);
